import React from 'react'
import {Socials} from './Socials'
import './ContactMe.css'

export const ContactMe = () => {
  return (
    <div id="contact-me">
            <center>
                <br/><br/>
                <Socials/>
                <br/><br/>
                <p style={{color:"rgb(255,255,255)", fontSize:"20px", fontWeight:"650"}}>Made with 💙 by Durgesh</p>
                <p style={{color:"rgb(255,255,255)"}}>Feel free to share your queries and feedbacks on my email</p>
                <a href="mailto:durgeshmahajan1722@gmail.com"  style={{textDecoration:"none", color: "rgb(42, 115, 240)", fontSize:"18px"}}>durgeshmahajan1722@gmail.com</a>
                <br/><br/>
            </center>
        </div>
  )
}